import { render } from "./ClientCart.vue?vue&type=template&id=54275fa8&scoped=true"
import script from "./ClientCart.vue?vue&type=script&lang=js"
export * from "./ClientCart.vue?vue&type=script&lang=js"

import "./ClientCart.vue?vue&type=style&index=0&id=54275fa8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54275fa8"]])

export default __exports__